module.exports = __webpack_public_path__ + "img/4.bc855312.jpg";